import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GenerateFileUploadItemsResponse } from '@/repositories/generated';

const response: GenerateFileUploadItemsResponse = {
  fileName: '01G7BSJRS44QC70T7T96J70Q2K.csv',
  presignedUrl: '/api/v1/presigned-url',
};

export const bulkImportGenerate = http.get(
  createMockEndpoint('/bulk_import/generate'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
